import { Skeleton } from '@/components/ui/skeleton';

function ListItemSkeleton() {
	return (
		<li className="hover:bg-accent/60 block p-3 space-y-1 leading-none transition-colors rounded-md cursor-pointer select-none">
			<div className="flex items-center space-x-3">
				{/* Avatar skeleton */}
				<Skeleton className="shrink-0 w-10 h-10 rounded-full" />

				<div className="space-y-2">
					{/* Title skeleton */}
					<Skeleton className="w-32 h-4" />

					{/* Description skeleton */}
					<Skeleton className="w-48 h-3" />
				</div>
			</div>
		</li>
	);
}

export default ListItemSkeleton;
